import imgAmazonPay from "../image/AmazonPay.png";
import imgApplePay from "../image/ApplePay.png";
import imgMastercard from "../image/Mastercard.png";
import imgUpi from "../image/upi.png";
import imgVisa from "../image/Visa.png";

/** Payment logos — informational display (checkout modal & footer). */
export const PAYMENT_METHODS = [
  { id: "upi", label: "UPI", src: imgUpi },
  { id: "visa", label: "Visa", src: imgVisa },
  { id: "mastercard", label: "Mastercard", src: imgMastercard },
  { id: "applepay", label: "Apple Pay", src: imgApplePay },
  { id: "amazonpay", label: "Amazon Pay", src: imgAmazonPay },
];
